import React from "react"
import Helpers, { isActiveChannel, channelApplyBtnShow } from "../../../../../config/Helpers";
import DeleteFilter from "../../../../../assets/iconos/close.svg";

class Channel extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            list_channels       : [],
            skip_channels_temp  : {},
            channels_search     : {},
            autoCompleteText    : ""
        }
    }
    componentDidMount(){
        this.setState({
            channels_search : this.props.filters_channels
        });
    }
    
    componentWillReceiveProps(props){ }

    filterByChannels(type){
        if(type === "default"){
            this.setState({
                skip_channels_temp : {}
            })
        }
        this.props.skipFilterChannel(this.state.skip_channels_temp, type)
    }
    handleAutoComplete(evt){
        const channels_search   = this.props.filters_channels;
        const text              = evt.target.value;

        this.setState({ 
           autoCompleteText : text 
        });
    }
    handleFilterSwitch(id, key, status)
    {
        if(status !== "block"){
            let channels = this.state.skip_channels_temp;
            
            if(this.state.skip_channels_temp[id] === undefined)   
                channels[id] = id;
            else
                delete channels[id];
            
            this.setState({
                skip_channels_temp : channels
            })
        }
    }
    render(){
        var $self               = this;
        const channels          = this.props.filters_channels;
        const channels_active   = this.props.current_filter_channel;

        if(Object.keys(channels).length > 0){

            let key_times     = this.props.layout.state.segmentActive;
            let key_times_aux = this.props.app._LayoutReview.state.key_time;
            let wdg_aux       = this.props.statics;
            if(key_times !== undefined && key_times_aux !== undefined){ 
                this.state.list_channels = Object.keys(wdg_aux).map((key, index) => {
                //if(wdg_aux[key].num_reservations !== 0){
                    if((channels[key] !== undefined)  && (key_times_aux[key] !== undefined)){
                        let segments = channels[key];
                        //segments["totals"] = "totals";
                        return Object.keys(segments).map((key_sgm, index_sgm) => {
                                if(key_times[key_sgm] !== undefined){
                                    let channels_list = segments[key_sgm];
                                    return Object.keys(channels_list).map((key_channel) => {
                                        const props = {
                                            key : "filter-listagencies-"+index_sgm,
                                            className : (key_channel === "totals" ? "totals" : (index_sgm%2 ? "row-c " : " "))
                                        }
                                        const child_name = key_channel === "totals" ? "TOTAL" : key_channel;

                                        return (<div {...props}>
                                                    <div>
                                                        <span title={child_name} className="channel-filter">{ child_name.length > 28 ? child_name.substr(0,28) + " [...]" : child_name} </span> 
                                                    </div>
                                                </div>);
                                    })
                                }else{
                                    const props = {
                                        key : "filter-listagencies-"+index_sgm,
                                        className : (key_sgm === "totals" ? "totals" : (index_sgm%2 ? "row-c " : " "))
                                    }

                                    return (<div {...props}>
                                        <div>
                                            <span className="channel-filter" />
                                        </div>
                                    </div>);
                                }
                            });
                        }else{
                            const props = {
                                key : "filter-listsegment-"+index,
                                className : index%2 ? "row-c" : ""
                            }
                            return (<div {...props}>
                                <div>
                                    <span className="channel-filter" />
                                </div>
                            </div>);
                        }
                    //}
                })
            }
        }
        let text_column = "SEGMENT";
        if(this.props.app.state.review_table_filter === "SEGMENT"){
            text_column = 'AGENCY'
        }
        return (
            <div className={"datagrid-widget by-chanel show-widget complete " + this.props.filter_segment_active}>
                <div className="container-fluid">
                    <div className="row header-widget">
                        <div className="col-md-12 options-widget">
                            <span className="title">AGENCY</span>
                        </div>
                    </div>
                    <div className="current-values">
                        <div className="row">
                            <div className="col-md-12 head-current">
                                {/* <input ref="text_ac" onKeyPress={this.handleAutoComplete.bind(this)} className="text-search-widget" placeholder="Search..." type="text" /> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 datagrid-list">
                                {this.state.list_channels}
                                <div className={"datagrid-month totals"}>
                                    <div> </div>
                                </div>
                                { /* <div className="filter-apply">
                                    <a className={"btn-apply " + channelApplyBtnShow([this.props.skip_channels, this.state.skip_channels_temp], "default") } onClick={this.filterByChannels.bind(this, 'default')} href="#">RESTAURAR</a>
                                    <a className={"btn-apply " + channelApplyBtnShow([this.props.skip_channels, this.state.skip_channels_temp], "filter") } onClick={this.filterByChannels.bind(this, 'filter')} href="#">APPLY</a>
                                </div> */ }
                            </div>
                        </div>
                    </div>   
                </div>
            </div>
        )
    }
}

export default Channel



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/views/Pickup/Channel.js